import { User } from './auth.interface';
import { Company } from './company.interface';
import { InvoiceInterface } from './invoice.interface';
import { ValueOf } from './shared.interface';
import { VatExceptionCategoryInterface } from './vatExceptionCategory.interface';

// List API is returning the full interface still
export interface ProductInList {
  id: string;
  name: string;
  internalSerial: number | null;
  createdAt: Date;
}

export interface Product extends ProductInList {
  internalId: string;
  description: string;
  productCategoryId: number;
  unitId: number;
  vatPercentageId: number;
  vatExceptionCategoryId?: number | null;
  saleCategoryId: number;
  saleCharacterizationId: number;
  validForTaxDeduction: boolean;
  companyId: string;
  updatedAt: Date;
  updatedBy: User;
  canDelete?: boolean;
}

export interface ProductInOrder {
  id: string;
  name: string;
  description: string;
  productId: string;
  productCategory: number;
  unit: string;
  unitId: number | null;
  product: Product;
  quantity: number;
  discountPercentage: number;
  price: number;
  finalCost: number;
  vatPercentage: number;
  vatPercentageRelationId: number;
  vatPercentageRelation?: VatPercentage;
  vatExceptionCategoryId: number;
  vatExceptionCategory: any;
  saleCategoryId: number;
  saleCharacterizationId: number;
  productCategoryId: number;
  companyId: string;
  company: Company;
  invoiceId: string | null;
  invoice: InvoiceInterface;
  deliveryNoteId: string | null;
  deliveryNote: InvoiceInterface;
  updatedById: string | null;
  updatedBy: User;
  createdAt: Date;
  updatedAt: Date;
}

export interface SaleCategory {
  id: number;
  aadeId: string;
  aadeCode: string;
  name: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface SaleCharacterization {
  id: number;
  aadeId: string;
  aadeCode: string;
  name: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface ProductCategory {
  id: number;
  aadeId: string;
  aadeCode: string;
  name: string;
  description: string;
}

export interface ProductUnit {
  id: number;
  aadeId: string;
  aadeCode: string;
  name: string;
  description: string;
}

export interface VatPercentage {
  id: number;
  name: string;
  description: string;
  value: number;
  reducedValue: number;
  aadeCode: ValueOf<typeof VAT_PERCENTAGE_AADE_CODE>;
  aadeCodeReducedVal: ValueOf<typeof VAT_PERCENTAGE_AADE_CODE>;
}

export const VAT_PERCENTAGE_AADE_CODE = {
  NO_VAT_PERC: '8',
  PERC_0: '7',
  PERC_4: '6',
  PERC_6: '3',
  PERC_9: '5',
  PERC_13: '2',
  PERC_17: '4',
  PERC_24: '1',
} as const;

export interface ProductFormData {
  saleCategories: SaleCategory[];
  vatPercentages: VatPercentage[];
  saleCharacterizations: SaleCharacterization[];
  vatExceptionCategories: VatExceptionCategoryInterface[];
  productCategories: ProductCategory[];
  units: ProductUnit[];
}

export const PRODUCT_CATEGORY_GOODS_AADE_ID = '0';
export const PRODUCT_CATEGORY_PRODUCTS_AADE_ID = '1';
